import log from 'loglevel';

/**
 * Retrieve caches object.
 */
export const globalCaches = (): CacheStorage | undefined => {
  return window.caches;
};

/**
 * Validate if Cache storage is supported.
 */
export const validateCaches = (): boolean => {
  if (globalCaches()) {
    return true;
  }
  log.error('Web APIs Cache is not supported');
  return false;
};

/**
 * Add resources to cache.
 * @param key Cache key.
 * @param resources the resourves to add.
 */
export const addAllCache = async (key: string, resources: Iterable<RequestInfo>) => {
  const cache = await openCache(key);
  await cache.addAll(resources);
};

/**
 * Delete a cache object.
 * @param key Cache key.
 */
export const deleteCache = async (key: string) => {
  const caches = globalCaches()!;
  await caches.delete(key);
};

/**
 * If cache name isn't present in the list of keep names, then delete it.
 * @param keepList Cache names to keep
 */
export const deleteUnknownCaches = async (keepList: string[]) => {
  const caches = globalCaches()!;
  const keys = await caches.keys();
  const deleteList = keys.filter(key => !keepList.includes(key));
  await Promise.all(deleteList.map(deleteCache));
};

/**
 * Open a Cache object.
 * @param key Cache key.
 */
export const openCache = async (key: string): Promise<Cache> => {
  const caches = globalCaches()!;
  return caches.open(key);
};
